import { Component, OnInit } from '@angular/core';

import {manutencoesModuleName} from "../../shared/data.service";
import {UtilService} from "../../../shared/services/util.service";
import {ManutencaoProgramadaApiService} from "../shared/manutencao-programada-api.service";
import {manutencoesProgramadaModuleName, selectedList, tiposVencimento} from "../shared/data.service";
import {frotasQuery} from "../../../bens/frotas/shared/data.service";
import {FrotaApiService} from "../../../bens/frotas/shared/frota-api.service";
import {FrotasService} from "../../../bens/frotas/shared/frota.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {ManutencaoProgramadaService} from "../shared/manutencao-programada.service";
import {ManutencaoProgramadaNavigationService} from "../shared/manutencao-programada-navigation.service";
import {OrdemServicoService} from "../../ordens-servico/shared/ordem-servico.service";
import {ServicoApiService} from "../../servicos/shared/servico-api.service";
import {OdometroHorimetroService} from "../../odometros-horimetros/shared/odometro-horimetro.service";
import {PlanoService} from "../../planos/shared/plano.service";

@Component({
    template: require('./manutencao-programada-list.component.html'),
    styles: [require('./manutencao-programada-list.component.css')]
})
export class ManutencaoProgramadaListComponent implements OnInit {
    list: any[] = [];
    loading: boolean = true;
    manutencaoProgramadaModuleName: any = manutencoesProgramadaModuleName;
    module: any = manutencoesModuleName;

    bemObject: any = {};
    frotaSelectId: string = 'frota';
    frotaQuery: any;
    tipoObject: any = {};
    tiposList: any[] = [];
    selectedObject: any = {};
    selectedList: any[] = [];
    selectedItem: any[] = [];

    private cloneList: any[] = [];
    private checkList: any[] = [];

    constructor(
        private _manutencaoProgramadaApiService: ManutencaoProgramadaApiService,
        private _manutencaoProgramadaService: ManutencaoProgramadaService,
        private _manutencaoProgramadaNavigationService: ManutencaoProgramadaNavigationService,
        private _frotaApiService: FrotaApiService,
        private _frotaService: FrotasService,
        private _utilService: UtilService,
        private _autocompleteService: AutoCompleteService,
        private _ordemServicoService: OrdemServicoService,
        private _servicoApiService: ServicoApiService,
        private _odometroHorimetroService: OdometroHorimetroService,
        private _planoService: PlanoService
    ) { }

    ngOnInit() {
        this.frotaQuery = this._utilService.cloneObject(frotasQuery);
        this.tiposList = this._utilService.cloneObject(tiposVencimento);
        this.tiposList.unshift({Key: null, Value: 'Todos'});
        this.selectedList = this._utilService.cloneObject(selectedList);
        this.selectedList.unshift({Key: null, Value: '— Selecione uma ação —'});
        this.selectedObject = this.selectedList[0];

        this.clickClear();

        this.getAll();
    }

    clickEdit(item: any) {
        this._manutencaoProgramadaNavigationService.goToServico(item.id);
    }

    clickManut(item: any) {
        this.changeItem(item, false);
        this.criarManutencao();
    }

    clickDelete(item?:any) {
        swal({
                title: "Você deseja realmente desativar este(s) serviço(s)?",
                text: "Este e todos os serviços futuros serão desativados.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Sim, Desativar",
                cancelButtonText: "Cancelar",
                closeOnConfirm: false
            },
            function() {
                let list: any[] = [],
                    x: number, lenX: number;

                if (item) {
                    list.push({id: item.id});
                } else {
                    for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
                        list.push({id: this.checkList[x].id});
                    }
                }

                this.onDelete(list);
            }.bind(this)
        );
    }

    clickClear() {
        this.bemObject = {};
        this.tipoObject = this.tiposList[1];
        this._autocompleteService.setValueOnSelect2(null, this.frotaSelectId);

        //this.list = this._utilService.cloneObject(this.cloneList);
        this.filterList();
    }

    changeTipo() {
        this.filterList();
    }

    changeSelected() {
        if (this.checkList.length) {
            if (this.selectedObject.Key === 1) {
                //criar manutencao

                let x: number, lenX: number,
                    bemId: number,
                    different: boolean = false;
                for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
                    if (!bemId) {
                        bemId =  this.checkList[x].bemId;
                    }

                    if (this.checkList[x].bemId !== bemId) {
                        different = true;
                        break;
                    }
                }

                if (different) {
                    this._utilService.swalMessageWarningCustom("A manutenção somente poderá ser criada para serviços de uma mesma Frota/equipamento");
                } else {
                    this.criarManutencao();
                }
            } else if(this.selectedObject.Key === 2) {
                //excluir
                this.clickDelete();
            }
        }
    }

    getFrotaObject(object: any) {
        this.bemObject = object;
        this.filterList();
    }

    frotaTemplateResult = (function(state: any) {
        let template: any = this._frotaService.templateResult(state, false);
        return template;
    }.bind(this));

    changeItem(item: any, splice:boolean) {
        let x: number, lenX: number,
            found: boolean = false;

        for (x = 0, lenX = this.checkList.length; x < lenX; x++) {
            if (item.id === this.checkList[x].id) {
                if (splice) {
                    this.checkList.splice(x, 1);
                }
                found = true;
                break;
            }
        }

        if (!found) {
            this.checkList.push(item);
        }
    }

    private getAll() {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                const minutes = 1000 * 60,
                    hours = minutes * 60,
                    days = hours * 24;

                var c: number;
                Response.forEach(function(item: any) {
                    if (item.StatusTempo && item.StatusTempo.Key) {
                        c = Math.round((item.InfoTempo.fim - item.InfoTempo.atual) / days);
                        c = (c < 0) ? (c * (-1)) : c;
                        item.InfoTempo.aVencer =  c;
                    } else {
                        item.StatusTempo = {};
                        item.InfoTempo = {};
                    }

                    item.referenciaTempo = this._planoService.getReferenciaTempo( item.referenciaTempo);

                    if (item.servico.descricao === 'Serviço B') {

                    }

                    if (item.StatusOdometroHorimetro && item.StatusOdometroHorimetro.Key) {
                        c = item.InfoOdometroHorimetro.fim - item.InfoOdometroHorimetro.atual;
                        c = (c < 0) ? (c * (-1)) : c;
                        item.InfoOdometroHorimetro.atual = this._odometroHorimetroService.setMask(item.InfoOdometroHorimetro.atual);
                        item.InfoOdometroHorimetro.fim = this._odometroHorimetroService.setMask(item.InfoOdometroHorimetro.fim);
                        item.InfoOdometroHorimetro.aVencer = this._odometroHorimetroService.setMask(c);
                    } else {
                        item.InfoOdometroHorimetro = {};
                        item.StatusOdometroHorimetro = {};
                    }
                }.bind(this));

                this.list = Response;
                this.cloneList = this._utilService.cloneObject(Response);
                this.filterList();
            }
            this.loading = false;
        }.bind(this));

        this._manutencaoProgramadaApiService.onGetAll(onDone);
    }

    private criarManutencao() {
        this._ordemServicoService.clearSessionStorage();
        this._manutencaoProgramadaService.setSessionStorage(this.checkList);
        this._manutencaoProgramadaNavigationService.goToNewOS();
    }

    private onDelete(items: any[]) {
        var onDone = (function(Response: any) {
            if (!Response.error)  {
                var x: number, lenX: number,
                    y: number, lenY: number;
                for (x = 0, lenX = this.list.length; x < lenX; x++) {
                    for (y = 0, lenY = items.length; y < lenY; y++) {
                        if (this.list[x].id === items[y].id) {
                            this.list[x].ativo = false;
                            break;
                        }
                    }
                }
                this._utilService.swalMessageDeleteSuccess();
            } else {
                this._utilService.swalMessageDeleteError();
            }
        }.bind(this));

        let obj: any = {Servicos: items};
        this._servicoApiService.onDeleteServicosBem(obj, onDone);
    }

    private filterList() {
        let x: number, lenX: number,
            list: any[] = [],
            f1: boolean, f2: boolean, f3: boolean;

        for (x = 0, lenX = this.cloneList.length; x < lenX; x++) {
            f1 = true;
            f2 = true;
            f3 = true;
            if (this.bemObject.id) {
                if (this.cloneList[x].bem.id !== this.bemObject.id) {
                    f1 = false;
                }
            }

            if (this.tipoObject && this.tipoObject.Key) {
                if (this.cloneList[x].StatusTempo) {
                    if (this.cloneList[x].StatusTempo.Key !== this.tipoObject.Key) {
                        f2 = false;
                    }
                }

                if (this.cloneList[x].StatusOdometroHorimetro) {
                    if (this.cloneList[x].StatusOdometroHorimetro.Key !== this.tipoObject.Key) {
                        f3 = false;
                    }
                }
            }

            if (f1 && (f2 || f3)) {
                list.push(this.cloneList[x]);
            }
        }

        this.list = list;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/manutencao-programada/manutencao-programada-list/manutencao-programada-list.component.ts
 **/